import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

const NotificationItem = ({ icon, title, description, time }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2, borderBottom: "1px solid #eee"}}>
      <Avatar sx={{ backgroundColor: "#F5F5F5", width: 40, height: 40 }}>
        {icon}
      </Avatar>
      <Box sx={{flexGrow:1,flexShrink:1}}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{lineHeight:1.2}}>{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{lineHeight:1.1}}>{description}</Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ marginLeft: "auto", width:"60px", textAlign:"center" }}>
        {time}
      </Typography>
    </Box>
  );
};

export default NotificationItem;
